import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../core/button/Button";
import { LogoText } from "../../../assets/icons";
import { cn } from "../../../util/classNameConstructor";
import { useIsMobile } from "../../../hooks/customDeviceDetect";

const AccessibilityStatement = ({ handleNavigateBack }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <div className="h-screen w-screen overflow-y-auto bg-[#fffefc]">
      <div className="ml-12 mt-7">
        <LogoText transform="scale(2)" />
      </div>
      <div className="mx-auto mt-48 max-w-3xl px-4 py-8">
        <Button
          variant="outline"
          leadingIcon="arrow-left-md"
          text={t("global:back")}
          onClick={handleNavigateBack}
        />
        <h1
          className={cn(
            "my-6 font-black",
            isMobile ? "heading-2xl" : "heading-5xl"
          )}
        >
          {" "}
          {t("accessibilityStatement:title")}
        </h1>

        <p className="body-lg mb-6">{t("accessibilityStatement:intro")}</p>

        <h2 className="heading-xl mb-4">
          {t("accessibilityStatement:conformance_status")}
        </h2>
        <p className="body-lg mb-6">
          {t("accessibilityStatement:conformance_details")}
        </p>

        <h2 className="heading-xl mb-4">
          {t("accessibilityStatement:conformance_exceptions")}
        </h2>

        <p className="body-lg mb-6">
          {t("accessibilityStatement:mapping_features")}
        </p>

        <h2 className="heading-xl mb-4">
          {t("accessibilityStatement:user_generated_content")}
        </h2>
        <p className="body-lg mb-6">
          {t("accessibilityStatement:user_content_details")}
        </p>

        <h2 className="heading-xl mb-4">
          {t("accessibilityStatement:compatibility")}
        </h2>
        <p className="body-lg mb-6">
          {t("accessibilityStatement:compatibility_details")}
        </p>

        <h2 className="heading-xl mb-4">
          {t("accessibilityStatement:search_function")}
        </h2>
        <p className="body-lg mb-6">
          {t("accessibilityStatement:search_function_details")}
        </p>

        <h2 className="heading-xl mb-4">
          {t("accessibilityStatement:assessment_method")}
        </h2>
        <p className="body-lg mb-6">
          {t("accessibilityStatement:assessment_method_details")}
        </p>

        <h2 className="heading-xl mb-4">
          {t("accessibilityStatement:feedback_process")}
        </h2>
        <p className="body-lg mb-6">
          {t("accessibilityStatement:feedback_details")} {t("imprint:address")}
        </p>

        <p className="body-xs text-right">
          {t("accessibilityStatement:last_updated", { date: "August 2024" })}
        </p>
      </div>
    </div>
  );
};

export default AccessibilityStatement;
